import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <svg className="hero-svg" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
          <defs>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{stopColor: '#667EEA', stopOpacity: 0.1}} />
              <stop offset="100%" style={{stopColor: '#764BA2', stopOpacity: 0.1}} />
            </linearGradient>
          </defs>
          
          {/* Animated circles */}
          <circle cx="100" cy="100" r="80" fill="url(#grad1)" className="float-1">
            <animate attributeName="cy" values="100;120;100" dur="4s" repeatCount="indefinite"/>
          </circle>
          <circle cx="1000" cy="200" r="60" fill="url(#grad1)" className="float-2">
            <animate attributeName="cy" values="200;180;200" dur="5s" repeatCount="indefinite"/>
          </circle>
          <circle cx="900" cy="600" r="100" fill="url(#grad1)" className="float-3">
            <animate attributeName="cy" values="600;620;600" dur="6s" repeatCount="indefinite"/>
          </circle>
          
          {/* Grid pattern */}
          <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(100, 255, 218, 0.05)" strokeWidth="1"/>
          </pattern>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>
      
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-name">Independent IT, Cloud & DevOps Consultant</h1>
          <h2 className="hero-tagline">scalable, reliable, and secure cloud platforms</h2>
          <p className="hero-description">
              DevOps and Cloud consultant with 9+ years of experience across IT operations,
              infrastructure, and cloud-native engineering. Specialized in designing and
              operating scalable platforms on AWS, Azure, and GCP, with deep expertise in
              CI/CD automation, Kubernetes-based architectures, and GitOps-driven
              delivery models for secure and reliable systems.
          </p>
          <div className="hero-cta">
            <a href="#contact" className="btn btn-secondary">Request Consultation</a>
            <a href="#projects" className="btn btn-primary">View My Work</a>
          </div>
        </div>
        
        <div className="hero-visual">
          <svg viewBox="0 0 500 500" className="hero-illustration">
            <defs>
              <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{stopColor: '#64FFDA', stopOpacity: 1}} />
                <stop offset="100%" style={{stopColor: '#5EEAD4', stopOpacity: 1}} />
              </linearGradient>
            </defs>
            
            {/* Server rack */}
            <rect x="150" y="100" width="200" height="300" rx="10" fill="var(--secondary-bg)" stroke="url(#grad2)" strokeWidth="2"/>
            
            {/* Server units */}
            {[0, 1, 2, 3, 4].map((i) => (
              <g key={i}>
                <rect x="170" y={120 + i * 50} width="160" height="35" rx="5" fill="var(--tertiary-bg)" stroke="url(#grad2)" strokeWidth="1"/>
                <circle cx="190" cy={137 + i * 50} r="3" fill="#51CF66">
                  <animate attributeName="opacity" values="1;0.3;1" dur="2s" repeatCount="indefinite"/>
                </circle>
                <circle cx="210" cy={137 + i * 50} r="3" fill="#51CF66">
                  <animate attributeName="opacity" values="1;0.3;1" dur="2.5s" repeatCount="indefinite"/>
                </circle>
                <circle cx="230" cy={137 + i * 50} r="3" fill="#FFD93D">
                  <animate attributeName="opacity" values="1;0.3;1" dur="1.8s" repeatCount="indefinite"/>
                </circle>
              </g>
            ))}
            
            {/* Cloud connection */}
            <g className="cloud-icon">
              <path d="M 250 50 Q 250 30 270 30 Q 290 30 290 50 Q 310 50 310 70 Q 310 90 290 90 L 230 90 Q 210 90 210 70 Q 210 50 230 50" 
                    fill="none" stroke="url(#grad2)" strokeWidth="3"/>
              <line x1="250" y1="90" x2="250" y2="100" stroke="url(#grad2)" strokeWidth="2"/>
            </g>
            
            {/* Floating particles */}
            {[...Array(8)].map((_, i) => (
              <circle key={i} cx={200 + (i * 20)} cy="250" r="2" fill="var(--accent)" opacity="0.6">
                <animate attributeName="cy" values="250;430;250" dur={3 + i * 0.5} repeatCount="indefinite"/>
              </circle>
            ))}
          </svg>
        </div>
      </div>
    </section>
  );
}

export default Hero;

